import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b50ab4a8")

_pushScopeId("data-v-b50ab4a8")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "按任务生成报告", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_13 = { style: {"display":"flex","justify-content":"space-between","margin-top":"10px"} }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "清除缓存", -1)
const _hoisted_16 = { class: "banner_btn" }
const _hoisted_17 = { class: "dialogTitle" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "AIGC Banner", -1)
const _hoisted_19 = { style: {"text-align":"center","margin":"20px 0px","color":"#3d86fb","font-size":"16px","font-weight":"bold"} }
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_24 = { class: "dialogTitle" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("手动生成报告-按任务")
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "el-icon-message-solid" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_28 = { class: "dialogTitle" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_31 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_37 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_39 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_41 = {
  class: "versionGeneration versionGeneration2",
  style: {}
}
const _hoisted_42 = { id: "perf_report" }
const _hoisted_43 = { class: "spacName" }
const _hoisted_44 = { class: "mainContent" }
const _hoisted_45 = { class: "spacName" }
const _hoisted_46 = { class: "gameTable" }
const _hoisted_47 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_48 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 测试版本: ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 报告创建时间: ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" 创建者: ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" 风险等级: ")
const _hoisted_53 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "客户端性能自动化测试")
], -1)
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" 测试平台: ")
const _hoisted_55 = {
  class: "corePerformance",
  style: {"margin-bottom":"20px"}
}
const _hoisted_56 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("测试结论")
], -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" 以下测试场景的部分模块占比变化比较大:")
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "text_blue" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" 的 ")
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("变化超过阈值2%.")
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "corePerformance" }
const _hoisted_68 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("核心指标风险详情")
], -1)
const _hoisted_69 = { class: "spacName" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = {
  key: 2,
  style: {"font-size":"16px","color":"#333","font-weight":"700","margin-bottom":"20px"}
}
const _hoisted_73 = {
  key: 3,
  class: "gameTable1"
}
const _hoisted_74 = /*#__PURE__*/_createVNode("tr", { style: {"background":"#f5f7fa","font-weight":"bold"} }, [
  /*#__PURE__*/_createVNode("td", { rowspan: 2 }, "测试场景"),
  /*#__PURE__*/_createVNode("td", { colspan: 5 }, " CPU功耗(ROG游戏手机2精英版,超高频率) ")
], -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("tr", { style: {"background":"#f5f7fa","font-weight":"bold"} }, [
  /*#__PURE__*/_createVNode("td", null, "CPU功耗"),
  /*#__PURE__*/_createVNode("td", null, "MAX(单核使用率)"),
  /*#__PURE__*/_createVNode("td", null, "AVG(单核使用率)"),
  /*#__PURE__*/_createVNode("td", null, "MAX(单核频率)"),
  /*#__PURE__*/_createVNode("td", null, "AVG(单核频率)")
], -1)
const _hoisted_76 = { key: 4 }
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { style: {"font-size":"16px","color":"#333","font-weight":"700","margin":"20px 0"} }, " GPU ", -1)
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = {
  class: "core-module",
  style: {"padding-top":"40px"}
}
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { style: {"font-size":"16px","color":"#333","font-weight":"700"} }, /*#__PURE__*/_toDisplayString("CPU&GPU详情"), -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("span", null, "  ", -1)
const _hoisted_83 = {
  key: 0,
  class: "FPStrend",
  style: {"margin-top":"20px"}
}
const _hoisted_84 = /*#__PURE__*/_createVNode("div", {
  id: "cpuFrequency",
  style: {"width":"100%","height":"450px"}
}, null, -1)
const _hoisted_85 = {
  key: 0,
  style: {"font-size":"16px","color":"#333","font-weight":"700","margin-bottom":"10px"}
}
const _hoisted_86 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("核心指标性能趋势")
], -1)
const _hoisted_87 = { class: "spacName" }
const _hoisted_88 = { class: "labelStyle" }
const _hoisted_89 = /*#__PURE__*/_createTextVNode("趋势图")
const _hoisted_90 = { class: "labelStyle2" }
const _hoisted_91 = { class: "spacName" }
const _hoisted_92 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("span", { class: "labelStyle" }, "CPU功耗趋势图"),
  /*#__PURE__*/_createVNode("span", { class: "labelStyle2" }, "     机型：ROG游戏手机2精英版")
], -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("div", {
  id: 'performance_line_cpu_power',
  style: {"width":"100%","height":"350px"}
}, null, -1)
const _hoisted_94 = { class: "detailedTest" }
const _hoisted_95 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("详细测试数据")
], -1)
const _hoisted_96 = { class: "describe" }
const _hoisted_97 = /*#__PURE__*/_createVNode("span", null, "灰色", -1)
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { class: "detailedTestTable" }
const _hoisted_100 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_101 = { class: "outerLayerTable" }
const _hoisted_102 = { class: "Table_Left" }
const _hoisted_103 = { colspan: 2 }
const _hoisted_104 = { key: 1 }
const _hoisted_105 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { colspan: 2 }, "性能数据链接")
], -1)
const _hoisted_106 = { class: "Table_Right" }
const _hoisted_107 = { id: "Table_Right_div" }
const _hoisted_108 = { class: "Table_Right_in" }
const _hoisted_109 = { colspan: 3 }
const _hoisted_110 = /*#__PURE__*/_createVNode("td", null, "old", -1)
const _hoisted_111 = /*#__PURE__*/_createVNode("td", null, "new", -1)
const _hoisted_112 = /*#__PURE__*/_createVNode("td", null, "趋势", -1)
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { key: 2 }
const _hoisted_116 = { key: 3 }
const _hoisted_117 = /*#__PURE__*/_createVNode("td", null, "--", -1)
const _hoisted_118 = {
  key: 0,
  class: "spacName2",
  style: {"overflow-x":"scroll"}
}
const _hoisted_119 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" CPU/功耗数据 ")
], -1)
const _hoisted_120 = { class: "outerLayerTable" }
const _hoisted_121 = /*#__PURE__*/_createVNode("td", { class: "Table_Left" }, [
  /*#__PURE__*/_createVNode("table", null, [
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { colspan: "2" }, "指标")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { colspan: "2" }, "数据项")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { colspan: "2" }, "CPU功耗")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { rowspan: "3" }, "CPU0功耗"),
      /*#__PURE__*/_createVNode("td", null, "单次功耗")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次使用率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次频率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { rowspan: "3" }, "CPU1功耗"),
      /*#__PURE__*/_createVNode("td", null, "单次功耗")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次使用率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次频率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { rowspan: "3" }, "CPU2功耗"),
      /*#__PURE__*/_createVNode("td", null, "单次功耗")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次使用率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次频率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { rowspan: "3" }, "CPU3功耗"),
      /*#__PURE__*/_createVNode("td", null, "单次功耗")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次使用率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次频率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { rowspan: "3" }, "CPU4功耗"),
      /*#__PURE__*/_createVNode("td", null, "单次功耗")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次使用率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次频率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { rowspan: "3" }, "CPU5功耗"),
      /*#__PURE__*/_createVNode("td", null, "单次功耗")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次使用率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次频率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { rowspan: "3" }, "CPU6功耗"),
      /*#__PURE__*/_createVNode("td", null, "单次功耗")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次使用率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次频率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", { rowspan: "3" }, "CPU7功耗"),
      /*#__PURE__*/_createVNode("td", null, "单次功耗")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次使用率")
    ]),
    /*#__PURE__*/_createVNode("tr", null, [
      /*#__PURE__*/_createVNode("td", null, "单次频率")
    ])
  ])
], -1)
const _hoisted_122 = { id: "Table_Right_div" }
const _hoisted_123 = { class: "Table_Right_in" }
const _hoisted_124 = { colspan: "3" }
const _hoisted_125 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", null, "old"),
  /*#__PURE__*/_createVNode("td", null, "new"),
  /*#__PURE__*/_createVNode("td", null, "趋势")
], -1)
const _hoisted_126 = { style: {"background-color":"#cccccc","color":"black"} }
const _hoisted_127 = { style: {"background-color":"#cccccc","color":"black","font-weight":"normal"} }
const _hoisted_128 = { style: {"background-color":"white","color":"black","font-weight":"normal"} }
const _hoisted_129 = { style: {"background-color":"#cccccc","color":"black","font-weight":"normal"} }
const _hoisted_130 = { style: {"background-color":"white","color":"black","font-weight":"normal"} }
const _hoisted_131 = { style: {"background-color":"#cccccc","color":"black","font-weight":"normal"} }
const _hoisted_132 = { style: {"background-color":"white","color":"black","font-weight":"normal"} }
const _hoisted_133 = {
  key: 1,
  class: "spacName2",
  style: {"overflow-x":"scroll"}
}
const _hoisted_134 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" GPU ")
], -1)
const _hoisted_135 = { class: "outerLayerTable" }
const _hoisted_136 = { class: "Table_Left" }
const _hoisted_137 = { key: 1 }
const _hoisted_138 = { id: "Table_Right_div" }
const _hoisted_139 = { class: "Table_Right_in" }
const _hoisted_140 = { colspan: "3" }
const _hoisted_141 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", null, "old"),
  /*#__PURE__*/_createVNode("td", null, "new"),
  /*#__PURE__*/_createVNode("td", null, "趋势")
], -1)
const _hoisted_142 = { style: {"background-color":"#cccccc","color":"black","font-weight":"normal"} }
const _hoisted_143 = { style: {"background-color":"#fff","color":"black","font-weight":"normal"} }
const _hoisted_144 = { key: 1 }
const _hoisted_145 = { class: "gallery__big_box" }
const _hoisted_146 = {
  ref: "mask",
  class: "gallery__big_wrap"
}
const _hoisted_147 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.name_search,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name_search = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.change_name_search
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nameList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: 
                        item.report_name +
                        '-[' +
                        item.create_date.replace('T', ' ') +
                        ']'
                      ,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_popconfirm, {
                              onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                              title: "确认删除该报告？",
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "info",
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              class: "editBtn",
                              size: "mini",
                              onClick: _ctx.handleEdit
                            }, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogFormVisible1,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogFormVisible1 = $event))
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_6, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.dialogFormVisible2
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_form, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告名称",
                                      "label-width": _ctx.formLabelWidth
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          class: "report-input",
                                          modelValue: _ctx.form1.name,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form1.name = $event)),
                                          autocomplete: "off",
                                          width: "500"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["label-width"])
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, _ctx.dialogFormVisible1]
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_9,
                                _hoisted_10
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode("div", null, [
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.generateReportsManuallyByTask,
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.generateReportsManually,
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "primary",
                          onClick: _ctx.clear,
                          disabled: _ctx.get_is_super,
                          style: {"height":"28px","margin-left":"auto"}
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              content: "暂无管理员权限",
                              placement: "top",
                              disabled: !_ctx.get_is_super
                            }, {
                              default: _withId(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _createVNode(_component_el_dialog, {
                      modelValue: _ctx.test,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.test = $event)),
                      width: "790px",
                      class: "banner_btn"
                    }, {
                      title: _withId(() => [
                        _createVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode(_component_el_divider)
                        ])
                      ]),
                      footer: _withId(() => [
                        _createVNode("span", _hoisted_20, [
                          _createVNode(_component_el_button, {
                            size: "small",
                            onClick: _ctx.Preview_btn
                          }, {
                            default: _withId(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "info",
                            size: "small",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.test = false))
                          }, {
                            default: _withId(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "success",
                            onClick: _ctx.confirm_btn
                          }, {
                            default: _withId(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_el_form, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              inline: true,
                              size: "mini",
                              label: "Banner主题"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.banner_name,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.banner_name = $event)),
                                  placeholder: "请选择",
                                  onChange: _ctx.bannerChang
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bannerList, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item,
                                        value: item
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onChange"])
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.banner_name == '全部'
                      ? _ctx.banner_img
                      : _ctx.banner_img.filter((v) => v.name == _ctx.banner_name), (item) => {
                              return (_openBlock(), _createBlock("div", {
                                key: item.name
                              }, [
                                _createVNode("div", _hoisted_19, _toDisplayString(item.name), 1),
                                _createVNode("div", null, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (url, index) => {
                                    return (_openBlock(), _createBlock(_component_el_image, {
                                      onClick: ($event: any) => (_ctx.imgBtn(index, url, item.name)),
                                      class: "img_border",
                                      style: 
                          'margin-bottom:10px;border:' +
                          (index === _ctx.img_index && item.name === _ctx.img_name
                            ? '2px solid #3D86FB;'
                            : '2px solid #F5F6FA')
                        ,
                                      key: index,
                                      src: url,
                                      lazy: ""
                                    }, null, 8, ["onClick", "style", "src"]))
                                  }), 128))
                                ])
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisibleByTask,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogFormVisibleByTask = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_24, [
                        _createVNode("span", null, [
                          _hoisted_25,
                          _createVNode(_component_el_tooltip, {
                            class: "item",
                            effect: "dark",
                            content: "如只选择测试任务, 则按照任务完成自动生成报告的逻辑生成一份报告",
                            placement: "top"
                          }, {
                            default: _withId(() => [
                              _hoisted_26
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReportByTask,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_27
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "对比任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "测试任务" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisible,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogFormVisible = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReport,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "旧版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "新版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                onChange: _ctx.selectVersion
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "场景" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.scenetion,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.generateReportVersion.scenetion = $event)),
                                multiple: "",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_scene_version, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.scene_id_id,
                                      label: item.scene_id__chinese,
                                      value: item.scene_id_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.localProject != 34 && _ctx.localProject != 40]
                          ])
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_31, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_32,
                                    _hoisted_33,
                                    _hoisted_34,
                                    _hoisted_35,
                                    _hoisted_36,
                                    _hoisted_37,
                                    _hoisted_38
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[20] || (_cache[20] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_39
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_40
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_41, [
                    _createVNode("p", null, [
                      _createVNode("b", null, _toDisplayString("版本号: " +
                    _ctx.new_report.new_version +
                    " - " +
                    "时间: " +
                    _ctx.new_report.create_date), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_42, [
                    _withDirectives(_createVNode("div", _hoisted_43, [
                      _createVNode("img", {
                        class: "banner",
                        src: _ctx.titleImg,
                        alt: ""
                      }, null, 8, ["src"])
                    ], 512), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode("div", _hoisted_44, [
                      _createVNode("div", _hoisted_45, [
                        _withDirectives(_createVNode("table", _hoisted_46, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_47, [
                              _createVNode("img", {
                                src: _ctx.get_core_data.project.icon
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("td", _hoisted_48, " 【" + _toDisplayString(_ctx.get_core_data.project.project_name) + "】 ", 1)
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_49,
                              _createVNode("span", null, _toDisplayString(_ctx.get_core_data.able_versions.android_new_version), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_50,
                              _createVNode("span", null, _toDisplayString(_ctx.new_report.create_date), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_51,
                              _createVNode("span", null, _toDisplayString(_ctx.new_report.creator), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _hoisted_52,
                              _createVNode("span", {
                                style: 
                            'color:' + _ctx.getColor(_ctx.risk) + ';font-weight:bold'
                          
                              }, _toDisplayString(_ctx.risk), 5)
                            ]),
                            _hoisted_53,
                            _createVNode("td", null, [
                              _hoisted_54,
                              _createVNode("span", null, _toDisplayString(_ctx.modelVal), 1)
                            ])
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _createVNode("div", null, [
                          _hoisted_57,
                          (_ctx.conclusion().length == 0)
                            ? (_openBlock(), _createBlock("span", _hoisted_58, "暂无"))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.conclusion(), (item, index) => {
                          return (_openBlock(), _createBlock("div", { key: index }, [
                            (_ctx.modelShow(index))
                              ? (_openBlock(), _createBlock("div", _hoisted_59, [
                                  _createVNode("div", null, _toDisplayString(index + 1) + "、" + _toDisplayString(item.name) + ":", 1),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (i, k, m) => {
                                    return (_openBlock(), _createBlock("div", {
                                      style: {"margin-bottom":"3px"},
                                      key: m
                                    }, [
                                      (i.length > 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_60, [
                                            _createVNode("span", _hoisted_61, "【" + _toDisplayString(k) + "】", 1),
                                            _hoisted_62,
                                            _createVNode("span", null, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(i, (num) => {
                                                return (_openBlock(), _createBlock("span", { key: num }, [
                                                  (num != 'avg_fps')
                                                    ? (_openBlock(), _createBlock("span", _hoisted_63, [
                                                        _createVNode("span", {
                                                          style: 
                                    'color:' + _ctx.riskColor(item.name, k, num)
                                  ,
                                                          class: "text_blue"
                                                        }, _toDisplayString(_ctx.get_field(num) + ","), 5)
                                                      ]))
                                                    : (_openBlock(), _createBlock("span", _hoisted_64, [
                                                        _createVNode("span", {
                                                          style: 
                                    'color:' + _ctx.riskColor(item.name, k, num)
                                  
                                                        }, _toDisplayString(_ctx.get_field(num)), 5),
                                                        _hoisted_65
                                                      ]))
                                                ]))
                                              }), 128)),
                                              (_ctx.text_show(i))
                                                ? (_openBlock(), _createBlock("span", _hoisted_66, "变化超过阈值10%"))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_67, [
                        _hoisted_68,
                        _createVNode("div", _hoisted_69, [
                          (_ctx.corePerformance.length > 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_70, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.corePerformance, (item) => {
                                  return (_openBlock(), _createBlock(_Fragment, {
                                    key: item.title
                                  }, [
                                    (_ctx.corePerformance.length > 1)
                                      ? (_openBlock(), _createBlock("h6", _hoisted_71, _toDisplayString(item.title), 1))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_set.content.core_index, (setting) => {
                                      return (_openBlock(), _createBlock(_component_el_table, {
                                        data: item.data,
                                        key: setting
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_table_column, {
                                            prop: "scene",
                                            label: "测试场景"
                                          }, {
                                            default: _withId((scope) => [
                                              _createVNode("span", null, _toDisplayString(scope.row?.scene), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            label: 
                              _ctx.get_field(setting) +
                              '趋势(vs. ' +
                              _ctx.get_core_data.able_versions.android_old_version +
                              ')'
                            
                                          }, _createSlots({
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.compare, (device, index) => {
                                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                                  key: Number(index),
                                                  label: _ctx.get_device_label(device, Number(index))
                                                }, {
                                                  default: _withId((scope) => [
                                                    _createVNode(_component_el_tooltip, {
                                                      effect: "dark",
                                                      placement: "top"
                                                    }, {
                                                      content: _withId(() => [
                                                        _createVNode("span", null, _toDisplayString(scope.row.new[index].data
                                          ?.game_version || "--") + " 对比 " + _toDisplayString(scope.row.old[index].data
                                          ?.game_version || "--"), 1)
                                                      ]),
                                                      default: _withId(() => [
                                                        _createVNode("span", {
                                                          style: 
                                      _ctx.compore_num(
                                        scope.row.new[index].data?.[setting],
                                        scope.row.old[index].data?.[setting],
                                        setting,
                                        scope.row,
                                        scope.row.new[index]
                                      )[3]
                                    
                                                        }, _toDisplayString(scope.row.new[index].data?.[setting] ||
                                      "--"), 5)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    (
                                    setting == 'max_pss' ||
                                    setting === 'avg_fps'
                                  )
                                                      ? (_openBlock(), _createBlock("span", {
                                                          key: 0,
                                                          id: "blodTypeId",
                                                          style: 
                                    'color:' +
                                    _ctx.riskColor(
                                      index,
                                      scope.row?.scene,

                                      setting,
                                      true
                                    )
                                  
                                                        }, _toDisplayString(_ctx.compore_num(
                                      scope.row.new[index].data?.[setting],
                                      scope.row.old[index].data?.[setting],
                                      setting,
                                      scope.row,
                                      scope.row.new[index]
                                    )[0]), 5))
                                                      : (_openBlock(), _createBlock("span", {
                                                          key: 1,
                                                          id: "blodTypeId",
                                                          style: 
                                    'color:' +
                                    _ctx.compore_num(
                                      scope.row.new[index].data?.[setting],
                                      scope.row.old[index].data?.[setting],
                                      setting,
                                      scope.row,
                                      scope.row.new[index]
                                    )[2]
                                  
                                                        }, _toDisplayString(_ctx.compore_num(
                                      scope.row.new[index].data?.[setting],
                                      scope.row.old[index].data?.[setting],
                                      setting,
                                      scope.row,
                                      scope.row.new[index]
                                    )[0]), 5))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["label"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, [
                                            (_ctx.tooltipData(_ctx.get_field(setting)) != '')
                                              ? {
                                                  name: "header",
                                                  fn: _withId(() => [
                                                    _createVNode(_component_el_tooltip, {
                                                      content: _ctx.tooltipData(_ctx.get_field(setting)),
                                                      placement: "top",
                                                      effect: "dark"
                                                    }, {
                                                      default: _withId(() => [
                                                        _createVNode("span", null, _toDisplayString(_ctx.get_field(setting) +
                                  "趋势(vs. " +
                                  _ctx.get_core_data.able_versions
                                    .android_old_version +
                                  ")"), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["content"])
                                                  ])
                                                }
                                              : undefined
                                          ]), 1032, ["label"]),
                                          _createVNode(_component_el_table_column, {
                                            prop: "trend",
                                            label: "趋势风险"
                                          }, {
                                            default: _withId((scope) => [
                                              _createVNode("span", {
                                                style: 
                                  'color:' + _ctx.getColor(scope.row?.[setting])
                                
                                              }, _toDisplayString(scope.row?.[setting]), 5)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["data"]))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock(_component_el_empty, {
                                key: 1,
                                description: "无数据"
                              })),
                          (
                        _ctx.get_core_data.all_device_id.indexOf(217) != -1 ||
                        _ctx.get_core_data.all_device_id.indexOf(564) != -1
                      )
                            ? (_openBlock(), _createBlock("div", _hoisted_72, " CPU功耗 "))
                            : _createCommentVNode("", true),
                          (
                        _ctx.get_core_data.all_device_id.indexOf(217) != -1 ||
                        _ctx.get_core_data.all_device_id.indexOf(564) != -1
                      )
                            ? (_openBlock(), _createBlock("table", _hoisted_73, [
                                _hoisted_74,
                                _hoisted_75,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.cpu_power_list, (scene) => {
                                  return (_openBlock(), _createBlock("tr", { key: scene }, [
                                    _createVNode("td", {
                                      style: 
                            scene.scene === '11城个人竞速'
                              ? 'font-weight:bold;font-size:13px;'
                              : 'font-size:13px;color: #606266;'
                          
                                    }, _toDisplayString(scene.scene), 5),
                                    _createVNode("td", {
                                      style: 
                            scene.scene === '11城个人竞速'
                              ? 'font-weight:bold;font-size:13px;'
                              : 'font-size:13px;color: #606266;'
                          
                                    }, [
                                      _createTextVNode(_toDisplayString(scene.data.new.sum_cpu_power
                              ? scene.data.new.sum_cpu_power
                              : "--") + " ", 1),
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.compore_power(
                                scene.data.new.sum_cpu_power,
                                scene.data.old.sum_cpu_power,
                                true
                              )[1]
                            
                                      }, _toDisplayString(_ctx.compore_power(
                                scene.data.new.sum_cpu_power,
                                scene.data.old.sum_cpu_power,
                                true
                              )[0]), 5)
                                    ], 4),
                                    _createVNode("td", {
                                      style: 
                            scene.scene === '11城个人竞速'
                              ? 'font-weight:bold;font-size:13px;'
                              : 'font-size:13px;color: #606266;'
                          
                                    }, [
                                      _createTextVNode(_toDisplayString(scene.data.new.max_cpu_usage
                              ? scene.data.new.max_cpu_usage
                              : "--") + " ", 1),
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.compore_power(
                                scene.data.new.max_cpu_usage,
                                scene.data.old.max_cpu_usage,
                                true
                              )[1]
                            
                                      }, _toDisplayString(_ctx.compore_power(
                                scene.data.new.max_cpu_usage,
                                scene.data.old.max_cpu_usage,
                                true
                              )[0]), 5)
                                    ], 4),
                                    _createVNode("td", {
                                      style: 
                            scene.scene === '11城个人竞速'
                              ? 'font-weight:bold;font-size:13px;'
                              : 'font-size:13px;color: #606266;'
                          
                                    }, [
                                      _createTextVNode(_toDisplayString(scene.data.new.avg_cpu_usage
                              ? scene.data.new.avg_cpu_usage
                              : "--") + " ", 1),
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.compore_power(
                                scene.data.new.avg_cpu_usage,
                                scene.data.old.avg_cpu_usage,
                                true
                              )[1]
                            
                                      }, _toDisplayString(_ctx.compore_power(
                                scene.data.new.avg_cpu_usage,
                                scene.data.old.avg_cpu_usage,
                                true
                              )[0]), 5)
                                    ], 4),
                                    _createVNode("td", {
                                      style: 
                            scene.scene === '11城个人竞速'
                              ? 'font-weight:bold;font-size:13px;'
                              : 'font-size:13px;color: #606266;'
                          
                                    }, [
                                      _createTextVNode(_toDisplayString(scene.data.new.max_cpu_freq
                              ? scene.data.new.max_cpu_freq
                              : "--") + " ", 1),
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.compore_power(
                                scene.data.new.max_cpu_freq,
                                scene.data.old.max_cpu_freq,
                                true
                              )[1]
                            
                                      }, _toDisplayString(_ctx.compore_power(
                                scene.data.new.max_cpu_freq,
                                scene.data.old.max_cpu_freq,
                                true
                              )[0]), 5)
                                    ], 4),
                                    _createVNode("td", {
                                      style: 
                            scene.scene === '11城个人竞速'
                              ? 'font-weight:bold;font-size:13px;'
                              : 'font-size:13px;color: #606266;'
                          
                                    }, [
                                      _createTextVNode(_toDisplayString(scene.data.new.avg_cpu_freq
                              ? scene.data.new.avg_cpu_freq
                              : "--") + " ", 1),
                                      _createVNode("span", {
                                        style: 
                              'color:' +
                              _ctx.compore_power(
                                scene.data.new.avg_cpu_freq,
                                scene.data.old.avg_cpu_freq,
                                true
                              )[1]
                            
                                      }, _toDisplayString(_ctx.compore_power(
                                scene.data.new.avg_cpu_freq,
                                scene.data.old.avg_cpu_freq,
                                true
                              )[0]), 5)
                                    ], 4)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (
                        _ctx.get_core_data.all_device_id.indexOf(216) != -1 ||
                        _ctx.get_core_data.all_device_id.indexOf(565) != -1
                      )
                            ? (_openBlock(), _createBlock("div", _hoisted_76, [
                                _hoisted_77,
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gpuTable, (key, val, i) => {
                                  return (_openBlock(), _createBlock("div", { key: i }, [
                                    _createVNode(_component_el_table, {
                                      data: _ctx.gpuTable[val]
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_table_column, {
                                          prop: "name",
                                          label: "测试场景",
                                          width: "100"
                                        }, {
                                          default: _withId((scope) => [
                                            _createVNode("span", null, _toDisplayString(scope.row?.name), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_table_column, { label: "GPU性能(荣耀20)" }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gpuList(val), (item) => {
                                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                                key: item.name,
                                                label: _ctx.checkCn(item.name),
                                                width: "120"
                                              }, _createSlots({
                                                default: _withId((scope) => [
                                                  (
                                    scope.row[item.name]?.new !=
                                    scope.row[item.name]?.old
                                  )
                                                    ? (_openBlock(), _createBlock("span", _hoisted_78, _toDisplayString(scope.row[item.name].new), 1))
                                                    : (_openBlock(), _createBlock("span", _hoisted_79, _toDisplayString(scope.row[item.name].new + "(--)"), 1)),
                                                  (scope.row[item.name].new != '--')
                                                    ? (_openBlock(), _createBlock("span", {
                                                        key: 2,
                                                        style: 
                                    'color:' +
                                    _ctx.compore_power(
                                      scope.row[item.name]?.new,
                                      scope.row[item.name]?.old,
                                      true
                                    )[1]
                                  
                                                      }, _toDisplayString(_ctx.compore_power(
                                      scope.row[item.name]?.new,
                                      scope.row[item.name]?.old,
                                      true
                                    )[0]), 5))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, [
                                                (item.value != '')
                                                  ? {
                                                      name: "header",
                                                      fn: _withId(() => [
                                                        _createVNode(_component_el_tooltip, {
                                                          content: item.value,
                                                          placement: "top",
                                                          effect: "dark"
                                                        }, {
                                                          default: _withId(() => [
                                                            _createVNode("span", null, _toDisplayString(_ctx.checkCn(item.name)), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["content"])
                                                      ])
                                                    }
                                                  : undefined
                                              ]), 1032, ["label"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["data"])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_80, [
                            _hoisted_81,
                            _createVNode(_component_el_form, { inline: true }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.selected_scene1,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.selected_scene1 = $event)),
                                      size: "mini",
                                      filterable: "",
                                      placeholder: "请选择场景",
                                      onChange: _ctx.selectSceneChange
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.scene_id,
                                            label: item.chinese,
                                            value: item.scene_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, null, {
                                  default: _withId(() => [
                                    _hoisted_82
                                  ]),
                                  _: 1
                                }),
                                (
                            _ctx.get_core_data.all_device_id.indexOf(217) != -1 ||
                            _ctx.get_core_data.all_device_id.indexOf(564) != -1
                          )
                                  ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          icon: "el-icon-refresh-right",
                                          size: "mini",
                                          circle: "",
                                          onClick: _ctx.change_name_search
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            (_ctx.RogShow)
                              ? (_openBlock(), _createBlock("div", _hoisted_83, [
                                  _createVNode(_component_el_card, null, {
                                    default: _withId(() => [
                                      _hoisted_84
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailed_types, (item, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: index,
                              class: "FPStrend"
                            }, [
                              (_ctx.detailedShow(item.value))
                                ? (_openBlock(), _createBlock("div", _hoisted_85, _toDisplayString(item.name), 1))
                                : _createCommentVNode("", true),
                              (_ctx.detailedShow(item.value))
                                ? (_openBlock(), _createBlock(_component_el_card, { key: 1 }, {
                                    default: _withId(() => [
                                      _createVNode("div", {
                                        id: item.value,
                                        style: {"width":"100%","height":"450px"}
                                      }, null, 8, ["id"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode("div", null, [
                        _hoisted_86,
                        _createVNode("div", null, [
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.selected_scene,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.selected_scene = $event)),
                                    size: "mini",
                                    filterable: "",
                                    placeholder: "请选择场景",
                                    onChange: _ctx.selectSceneChange
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.scene_id,
                                          label: item.chinese,
                                          value: item.scene_id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("div", _hoisted_87, [
                          (_ctx.subChart.length !== _ctx.target_types.length)
                            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.target_types, (item, index) => {
                                return _withDirectives((_openBlock(), _createBlock("div", { key: index }, [
                                  (_ctx.checkPie(_ctx.pieShow(index, item.value)))
                                    ? (_openBlock(), _createBlock(_component_el_card, {
                                        key: 0,
                                        class: "FPStrend"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode("p", null, [
                                            _createVNode("span", _hoisted_88, [
                                              _createTextVNode(_toDisplayString(item.label), 1),
                                              _createVNode("span", null, _toDisplayString(_ctx.checkCn1(item.label)), 1),
                                              _hoisted_89
                                            ]),
                                            _createVNode("span", _hoisted_90, "     场景：" + _toDisplayString(_ctx.get_scene_chinese), 1)
                                          ]),
                                          _createVNode("div", {
                                            id: 'performance_line' + index,
                                            style: {"width":"100%","height":"350px"}
                                          }, null, 8, ["id"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ], 512)), [
                                  [_directive_loading, _ctx.loading]
                                ])
                              }), 128))
                            : (_openBlock(), _createBlock(_component_el_empty, {
                                key: 1,
                                description: "无数据"
                              }))
                        ]),
                        _createVNode("div", _hoisted_91, [
                          (
                        _ctx.get_core_data.cpu_power_trend.x_axis_format.length !== 0
                      )
                            ? _withDirectives((_openBlock(), _createBlock(_component_el_card, {
                                key: 0,
                                class: "FPStrend"
                              }, {
                                default: _withId(() => [
                                  _hoisted_92,
                                  _hoisted_93
                                ]),
                                _: 1
                              }, 512)), [
                                [_directive_loading, _ctx.loading]
                              ])
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", _hoisted_94, [
                        _hoisted_95,
                        _createVNode("p", _hoisted_96, [
                          _hoisted_97,
                          _createTextVNode("为上个版本数据，白色为当前内网最新版本数据。  当前版本:" + _toDisplayString(_ctx.get_core_data.able_versions.android_new_version) + "  对比版本: " + _toDisplayString(_ctx.get_core_data.able_versions.android_old_version), 1)
                        ]),
                        (_ctx.get_core_data.report_list2.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_98, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.report_list2, (scene) => {
                                return _withDirectives((_openBlock(), _createBlock("div", {
                                  key: scene.scene_id,
                                  class: "spacName2"
                                }, [
                                  _createVNode("div", _hoisted_99, [
                                    _createVNode("h5", null, [
                                      _hoisted_100,
                                      _createTextVNode(" " + _toDisplayString(scene.scene), 1)
                                    ]),
                                    _createVNode("table", _hoisted_101, [
                                      _createVNode("tr", null, [
                                        _createVNode("td", _hoisted_102, [
                                          _createVNode("table", null, [
                                            _createVNode("tr", null, [
                                              _createVNode("td", _hoisted_103, _toDisplayString(scene.scene), 1)
                                            ]),
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.indexClassification(
                                    scene.custom_index
                                  ), (item, index) => {
                                              return (_openBlock(), _createBlock("tr", { key: index }, [
                                                _createVNode("td", {
                                                  style: {"width":"175px","overflow":"hidden","max-width":"175px"},
                                                  title: item.dataItem
                                                }, [
                                                  (_ctx.tooltipData(item.dataItem) != '')
                                                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                        key: 0,
                                                        content: _ctx.tooltipData(item.dataItem),
                                                        placement: "top",
                                                        effect: "dark"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode("span", null, _toDisplayString(item.dataItem +
                                          _ctx.checkCn1(item.dataItem)), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["content"]))
                                                    : (_openBlock(), _createBlock("span", _hoisted_104, _toDisplayString(item.dataItem + _ctx.checkCn1(item.dataItem)), 1))
                                                ], 8, ["title"])
                                              ]))
                                            }), 128)),
                                            _hoisted_105,
                                            _createVNode("tr", null, [
                                              _createVNode("td", {
                                                colspan: 2,
                                                class: _ctx.scroll ? 'scrollTD2' : 'scrollTD'
                                              }, null, 2)
                                            ])
                                          ])
                                        ]),
                                        _createVNode("td", _hoisted_106, [
                                          _createVNode("div", _hoisted_107, [
                                            _createVNode("table", null, [
                                              _createVNode("tr", null, [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(scene.device_list, (device, d_index) => {
                                                  return (_openBlock(), _createBlock("td", { key: d_index }, [
                                                    _createVNode("table", _hoisted_108, [
                                                      _createVNode("tr", null, [
                                                        _createVNode("td", _hoisted_109, _toDisplayString(device), 1)
                                                      ]),
                                                      _createVNode("tr", null, [
                                                        _createVNode(_component_el_tooltip, {
                                                          effect: "dark",
                                                          placement: "top"
                                                        }, {
                                                          content: _withId(() => [
                                                            _createVNode("span", null, _toDisplayString(scene.old[d_index].data
                                                  ?.game_version || "--"), 1)
                                                          ]),
                                                          default: _withId(() => [
                                                            _hoisted_110
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_el_tooltip, {
                                                          effect: "dark",
                                                          placement: "top"
                                                        }, {
                                                          content: _withId(() => [
                                                            _createVNode("span", null, _toDisplayString(scene.new[d_index].data
                                                  ?.game_version || "--"), 1)
                                                          ]),
                                                          default: _withId(() => [
                                                            _hoisted_111
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _hoisted_112
                                                      ]),
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.all_index(
                                            scene.custom_index
                                          ), (i, i_index) => {
                                                        return (_openBlock(), _createBlock("tr", { key: i_index }, [
                                                          (
                                              scene.old[d_index].data?.[i] !==
                                                null &&
                                              scene.old[d_index].data?.[i] !==
                                                '' &&
                                              scene.old[d_index].data?.[i] !==
                                                undefined
                                            )
                                                            ? (_openBlock(), _createBlock("td", _hoisted_113, _toDisplayString(scene.old[d_index].data?.[i]), 1))
                                                            : (_openBlock(), _createBlock("td", _hoisted_114, "--")),
                                                          (
                                              scene.new[d_index].data?.[i] !==
                                                '' &&
                                              scene.new[d_index].data?.[i] !==
                                                null &&
                                              scene.new[d_index].data?.[i] !==
                                                undefined
                                            )
                                                            ? (_openBlock(), _createBlock("td", _hoisted_115, _toDisplayString(scene.new[d_index].data?.[i]), 1))
                                                            : (_openBlock(), _createBlock("td", _hoisted_116, "--")),
                                                          _createVNode("td", {
                                                            style: 
                                              'color: ' +
                                              _ctx.compore_num(
                                                scene.new[d_index].data?.[i],
                                                scene.old[d_index].data?.[i],
                                                i
                                              )[4]
                                            
                                                          }, _toDisplayString(_ctx.compore_num(
                                                scene.new[d_index].data?.[i],
                                                scene.old[d_index].data?.[i],
                                                i
                                              )[0] || "--"), 5)
                                                        ]))
                                                      }), 128)),
                                                      _createVNode("tr", null, [
                                                        _createVNode("td", null, [
                                                          _createVNode("a", {
                                                            target: "_blank",
                                                            href: 
                                                _ctx.get_url(
                                                  scene.old[d_index].data?.url
                                                )
                                              
                                                          }, "链接", 8, ["href"])
                                                        ]),
                                                        _createVNode("td", null, [
                                                          _createVNode("a", {
                                                            target: "_blank",
                                                            href: 
                                                _ctx.get_url(
                                                  scene.new[d_index].data?.url
                                                )
                                              
                                                          }, "链接", 8, ["href"])
                                                        ]),
                                                        _hoisted_117
                                                      ])
                                                    ])
                                                  ]))
                                                }), 128))
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 512)), [
                                  [_directive_loading, _ctx.loading]
                                ])
                              }), 128)),
                              (
                        _ctx.get_core_data.all_device_id.indexOf(217) != -1 ||
                        _ctx.get_core_data.all_device_id.indexOf(564) != -1
                      )
                                ? (_openBlock(), _createBlock("div", _hoisted_118, [
                                    _hoisted_119,
                                    _createVNode("table", _hoisted_120, [
                                      _createVNode("tr", null, [
                                        _hoisted_121,
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.cpu_power_list, (scene) => {
                                          return (_openBlock(), _createBlock("td", {
                                            class: "Table_Right",
                                            key: scene
                                          }, [
                                            _createVNode("div", _hoisted_122, [
                                              _createVNode("table", _hoisted_123, [
                                                _createVNode("tr", null, [
                                                  _createVNode("td", _hoisted_124, _toDisplayString(scene.scene), 1)
                                                ]),
                                                _hoisted_125,
                                                _createVNode("tr", null, [
                                                  _createVNode("td", _hoisted_126, _toDisplayString(scene.data.old.sum_cpu_power
                                        ? scene.data.old.sum_cpu_power
                                        : "--"), 1),
                                                  _createVNode("td", null, _toDisplayString(scene.data.new.sum_cpu_power
                                        ? scene.data.new.sum_cpu_power
                                        : "--"), 1),
                                                  _createVNode("td", {
                                                    style: 
                                      'color:' +
                                      _ctx.compore_power(
                                        scene.data.new['cpu_power_' + _ctx.index],
                                        scene.data.old['cpu_power_' + _ctx.index],
                                        false
                                      )[1]
                                    
                                                  }, _toDisplayString(_ctx.compore_power(
                                        scene.data.new["cpu_power_" + _ctx.index],
                                        scene.data.old["cpu_power_" + _ctx.index],
                                        false
                                      )[0]), 5)
                                                ]),
                                                (_openBlock(), _createBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7], (index) => {
                                                  return _createVNode("tbody", { key: index }, [
                                                    _createVNode("tr", null, [
                                                      _createVNode("td", _hoisted_127, _toDisplayString(scene.data.old["cpu_power_" + index]
                                          ? scene.data.old["cpu_power_" + index]
                                          : "--"), 1),
                                                      _createVNode("td", _hoisted_128, _toDisplayString(scene.data.new["cpu_power_" + index]
                                          ? scene.data.new["cpu_power_" + index]
                                          : "--"), 1),
                                                      _createVNode("td", {
                                                        style: 
                                        'background-color:white;' +
                                        'color:' +
                                        _ctx.compore_power(
                                          scene.data.new['cpu_power_' + index],
                                          scene.data.old['cpu_power_' + index],
                                          false
                                        )[1] +
                                        ';font-weight:normal'
                                      
                                                      }, _toDisplayString(_ctx.compore_power(
                                          scene.data.new["cpu_power_" + index],
                                          scene.data.old["cpu_power_" + index],
                                          false
                                        )[0]), 5)
                                                    ]),
                                                    _createVNode("tr", null, [
                                                      _createVNode("td", _hoisted_129, _toDisplayString(scene.data.old["cpu_usage_" + index]
                                          ? scene.data.old["cpu_usage_" + index]
                                          : "--"), 1),
                                                      _createVNode("td", _hoisted_130, _toDisplayString(scene.data.new["cpu_usage_" + index]
                                          ? scene.data.new["cpu_usage_" + index]
                                          : "--"), 1),
                                                      _createVNode("td", {
                                                        style: 
                                        'background-color:white;' +
                                        'color:' +
                                        _ctx.compore_power(
                                          scene.data.new['cpu_usage_' + index],
                                          scene.data.old['cpu_usage_' + index],
                                          false
                                        )[1] +
                                        ';font-weight:normal'
                                      
                                                      }, _toDisplayString(_ctx.compore_power(
                                          scene.data.new["cpu_usage_" + index],
                                          scene.data.old["cpu_usage_" + index],
                                          false
                                        )[0]), 5)
                                                    ]),
                                                    _createVNode("tr", null, [
                                                      _createVNode("td", _hoisted_131, _toDisplayString(scene.data.old["cpu_freq_" + index]
                                          ? scene.data.old["cpu_freq_" + index]
                                          : "--"), 1),
                                                      _createVNode("td", _hoisted_132, _toDisplayString(scene.data.new["cpu_freq_" + index]
                                          ? scene.data.new["cpu_freq_" + index]
                                          : "--"), 1),
                                                      _createVNode("td", {
                                                        style: 
                                        'background-color:white;' +
                                        'color:' +
                                        _ctx.compore_power(
                                          scene.data.new['cpu_freq_' + index],
                                          scene.data.old['cpu_freq_' + index],
                                          false
                                        )[1] +
                                        ';font-weight:normal'
                                      
                                                      }, _toDisplayString(_ctx.compore_power(
                                          scene.data.new["cpu_freq_" + index],
                                          scene.data.old["cpu_freq_" + index],
                                          false
                                        )[0]), 5)
                                                    ])
                                                  ])
                                                }), 64))
                                              ])
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                        _ctx.get_core_data.all_device_id.indexOf(216) != -1 ||
                        _ctx.get_core_data.all_device_id.indexOf(565) != -1
                      )
                                ? (_openBlock(), _createBlock("div", _hoisted_133, [
                                    _hoisted_134,
                                    _createVNode("table", _hoisted_135, [
                                      _createVNode("tr", null, [
                                        _createVNode("td", _hoisted_136, [
                                          _createVNode("table", null, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gpuAllTable, (item) => {
                                              return (_openBlock(), _createBlock("tr", { key: item }, [
                                                _createVNode("td", null, [
                                                  (item.value != '')
                                                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                        key: 0,
                                                        content: item.value,
                                                        placement: "top",
                                                        effect: "dark"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode("span", null, _toDisplayString(item.cnName + _ctx.checkCn1(item.cnName)), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["content"]))
                                                    : (_openBlock(), _createBlock("span", _hoisted_137, _toDisplayString(item.cnName + _ctx.checkCn1(item.cnName)), 1))
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.cpu_power_list.filter(
                              (v) => v.scene != '11城个人竞速-极限测试'
                            ), (scene) => {
                                          return (_openBlock(), _createBlock("td", {
                                            class: "Table_Right",
                                            key: scene
                                          }, [
                                            _createVNode("div", _hoisted_138, [
                                              _createVNode("table", _hoisted_139, [
                                                _createVNode("tr", null, [
                                                  _createVNode("td", _hoisted_140, _toDisplayString(scene.scene), 1)
                                                ]),
                                                _hoisted_141,
                                                (_openBlock(), _createBlock(_Fragment, null, _renderList([
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9,
                                    10,
                                    11,
                                    12,
                                    13,
                                    14,
                                    15,
                                    16,
                                    17,
                                    18,
                                    19,
                                    20,
                                    21,
                                    22,
                                    23,
                                    24,
                                    25,
                                    26,
                                    27,
                                    28,
                                    29,
                                  ], (item) => {
                                                  return _createVNode("tbody", { key: item }, [
                                                    _createVNode("tr", null, [
                                                      _createVNode("td", _hoisted_142, _toDisplayString(scene.data.old_glory_20[
                                          _ctx.gpuAllTable[item].engName
                                        ] == undefined || null
                                          ? "--"
                                          : scene.data.old_glory_20[
                                              _ctx.gpuAllTable[item].engName
                                            ]), 1),
                                                      _createVNode("td", _hoisted_143, _toDisplayString(scene.data.new_glory_20[
                                          _ctx.gpuAllTable[item].engName
                                        ] == undefined || null
                                          ? "--"
                                          : scene.data.new_glory_20[
                                              _ctx.gpuAllTable[item].engName
                                            ]), 1),
                                                      _createVNode("td", {
                                                        style: 
                                        'background-color:white;' +
                                        'color:' +
                                        _ctx.compore_power(
                                          scene.data.new_glory_20[
                                            _ctx.gpuAllTable[item].engName
                                          ],
                                          scene.data.old_glory_20[
                                            _ctx.gpuAllTable[item].engName
                                          ],
                                          false
                                        )[1] +
                                        ';font-weight:normal'
                                      
                                                      }, _toDisplayString(_ctx.compore_power(
                                          scene.data.new_glory_20[
                                            _ctx.gpuAllTable[item].engName
                                          ],
                                          scene.data.old_glory_20[
                                            _ctx.gpuAllTable[item].engName
                                          ],
                                          false
                                        )[0]), 5)
                                                    ])
                                                  ])
                                                }), 64))
                                              ])
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_144, [
                              _createVNode(_component_el_empty, { description: "无数据" })
                            ]))
                      ])
                    ])
                  ])
                ]),
                _withDirectives(_createVNode("div", {
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.maskBtn($event))),
                  class: "gallery__big"
                }, [
                  _createVNode("div", _hoisted_145, [
                    _createVNode("div", _hoisted_146, [
                      _createVNode("img", { src: _ctx.mask_img }, null, 8, ["src"])
                    ], 512)
                  ])
                ], 512), [
                  [_vShow, _ctx.showMask]
                ]),
                _hoisted_147
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})